import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "sm:flex sm:items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sm:flex-auto" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-semibold leading-6 text-gray-900" }, "Detailss"),
    /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm text-gray-700" }, "Kriter girilmez ise son 1 aydaki oturumları gösterir. ")
  ])
], -1)
const _hoisted_2 = { class: "mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6" }
const _hoisted_3 = { class: "sm:col-span-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "usermail",
  class: "block text-sm font-medium leading-6 text-gray-900"
}, "User e-mail", -1)
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "userId",
    class: "block text-sm font-medium leading-6 text-gray-900"
  }, "User Id"),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      name: "userId",
      id: "userId",
      autocomplete: "off",
      "v:model": "userId",
      class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
    })
  ])
], -1)
const _hoisted_7 = { class: "sm:col-span-3" }
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "sm:flex sm:items-center mt-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sm:flex-auto" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold leading-6 text-gray-900" }, "User")
  ])
], -1)
const _hoisted_10 = { class: "mt-2 flow-root" }
const _hoisted_11 = { class: "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_12 = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_13 = {
  key: 0,
  class: "min-w-full divide-y divide-gray-300"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
    }, " e-Mail"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
    }, " Name")
  ])
], -1)
const _hoisted_15 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_16 = { class: "whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-0" }
const _hoisted_17 = { class: "whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "sm:flex sm:items-center mt-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sm:flex-auto" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold leading-6 text-gray-900" }, "Organization")
  ])
], -1)
const _hoisted_19 = { class: "mt-2 flow-root" }
const _hoisted_20 = { class: "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_21 = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_22 = {
  key: 0,
  class: "min-w-full divide-y divide-gray-300"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
    }, " e-Mail"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
    }, " Name")
  ])
], -1)
const _hoisted_24 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_25 = { class: "whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-0" }
const _hoisted_26 = { class: "whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "sm:flex sm:items-center mt-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sm:flex-auto" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold leading-6 text-gray-900" }, "Flows")
  ])
], -1)
const _hoisted_28 = { class: "mt-2 flow-root" }
const _hoisted_29 = { class: "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_30 = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_31 = {
  key: 0,
  class: "min-w-full divide-y divide-gray-300"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
    }, " Id"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
    }, " Subject"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
    }, " Creation date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
    }, " Type"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
    }, " Status"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
    }, " Item count ")
  ])
], -1)
const _hoisted_33 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_34 = { class: "whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-0" }
const _hoisted_35 = { class: "whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900" }
const _hoisted_36 = { class: "whitespace-nowrap px-2 py-2 text-sm text-gray-900" }
const _hoisted_37 = { class: "whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900" }
const _hoisted_38 = { class: "whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900" }
const _hoisted_39 = { class: "whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "usermail",
            id: "usermail",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          }, null, 512), [
            [_vModelText, _ctx.email]
          ])
        ])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reportUserDetails())),
            class: "rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          }, "List")
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_ctx.reportUserDetailsResult && _ctx.reportUserDetailsResult.user)
            ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("tbody", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportUserDetailsResult.user, (value, key) => {
                    return (_openBlock(), _createElementBlock("tr", { key: key }, [
                      _createElementVNode("td", _hoisted_16, _toDisplayString(key), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(value), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_18,
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          (_ctx.reportUserDetailsResult && _ctx.reportUserDetailsResult.organization)
            ? (_openBlock(), _createElementBlock("table", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("tbody", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportUserDetailsResult.organization, (value, key) => {
                    return (_openBlock(), _createElementBlock("tr", { key: key }, [
                      _createElementVNode("td", _hoisted_25, _toDisplayString(key), 1),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(value), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_27,
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          (_ctx.reportUserDetailsResult && _ctx.reportUserDetailsResult.flows)
            ? (_openBlock(), _createElementBlock("table", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("tbody", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportUserDetailsResult.flows, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", _hoisted_34, _toDisplayString(item.id), 1),
                      _createElementVNode("td", _hoisted_35, _toDisplayString(item.subject), 1),
                      _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.formatDateLong(item.createdDate)), 1),
                      _createElementVNode("td", _hoisted_37, _toDisplayString(item.flowTypeDescription), 1),
                      _createElementVNode("td", _hoisted_38, _toDisplayString(item.statusDescription), 1),
                      _createElementVNode("td", _hoisted_39, _toDisplayString(item.flowItemCount), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}